import { Card } from "@devhop/ui";
import { useNavigate } from "@tanstack/react-router";
import { usePermissions } from "@/modules/auth/presentation/model/usePermissions";
import { dashboardLayout } from "../lib/dashboard-layout";
import { dashboardShortcuts } from "../config/shortcuts";
import { ChevronRight } from "lucide-react";

export function DashboardShortcuts() {
  const { hasAny } = usePermissions();
  const navigate = useNavigate();

  const visible = dashboardShortcuts.filter((item) =>
    hasAny(item.permissionsAny),
  );

  if (visible.length === 0) return null;

  return (
    <div>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
        {visible.map((item) => {
          const Icon = item.icon;
          return (
            <Card
              key={item.url}
              className={`cursor-pointer border border-border bg-card transition-colors hover:bg-muted/50 ${dashboardLayout.cardChrome} ${dashboardLayout.cardPad}`}
              onClick={() => navigate({ to: item.url })}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  navigate({ to: item.url });
                }
              }}
            >
              <div className="flex items-center justify-between gap-2">
                <div className="flex items-center gap-3">
                  <div className="flex size-10 shrink-0 items-center justify-center rounded-lg bg-primary/10">
                    <Icon className="size-5 text-primary" />
                  </div>
                  <span className="font-medium">{item.title}</span>
                </div>
                <ChevronRight className="size-4 shrink-0 text-muted-foreground" />
              </div>
            </Card>
          );
        })}
      </div>
    </div>
  );
}
